import * as React from 'react'
import PropTypes from 'prop-types'
import Hemicycle from './Hemicycle'
import ScrollMagic from 'ScrollMagic'
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators'

import './HemicycleFocus.css'

class HemicycleFocus extends React.Component {
  constructor (props) {
    super(props)

    this.scene = null
    this.scrollController = null
    this.state = {
      fixed: false
    }
    this.mobile = false
  }

  componentDidMount () {
    console.log(this.props.num)
    if (window.innerWidth < 1280) {
      console.log('Small device')
      this.mobile = true
    }
    this.initScroller()
    this.updateScrollDuration()
    window.addEventListener('resize', () => {
      this.updateScrollDuration()
    })
  }

  componentWillUnmount () {
    window.removeEventListener('resize', () => {
      this.updateScrollDuration()
    })
  }

  updateScrollDuration () {
    let newDuration = window.innerHeight * (this.props.height - 0)
    this.scene.duration(newDuration)
  }

  initScroller () {
    this.scrollController = new ScrollMagic.Controller()
    this.scene = new ScrollMagic.Scene({
      triggerElement: this.node,
      triggerHook: this.mobile ? 0 : 0,
      reverse: true
    })
    this.scene.on('enter', event => {
      console.log('ENTER SCENE')
      this.spacerInnerNode.style.width = this.node.offsetWidth + 'px'
      this.setState({ fixed: true })
      if (event.scrollDirection === 'REVERSE') {
        this.spacerInnerNode.style.top = '0'
      }
    })
    this.scene.on('leave', event => {
      // If going downward
      if (event.scrollDirection === 'FORWARD') {
        console.log('LEAVE SCENE FORWARD')
        this.spacerNode.style.paddingTop = '0px'
        this.spacerInnerNode.style.top =
          window.innerHeight * this.props.height + 'px'
        // Else if going upward
      } else if (event.scrollDirection === 'REVERSE') {
        console.log('LEAVE SCENE REVERSE')
        this.spacerNode.style.paddingTop = '0px'
        this.spacerInnerNode.style.top = '0'
      }
      this.setState({ fixed: false })
    })
    // this.scene.addIndicators()
    this.scrollController.addScene(this.scene)
  }

  getClassNames () {
    return 'hemicyclefocus-spacer' + (this.state.fixed ? ' fixed' : '')
  }

  render () {
    return (
      <div
        ref={node => {
          this.node = node
        }}
      >
        <div
          ref={node => {
            this.spacerNode = node
          }}
          className={this.getClassNames()}
        >
          <div
            className='spacer-inner'
            ref={node => {
              this.spacerInnerNode = node
            }}
          >
            <div className='hemicyclefocus-container'>
              <Hemicycle mapId={this.props.deputiesCount} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

HemicycleFocus.propTypes = {
  height: PropTypes.number,
  num: PropTypes.number,
  // title: PropTypes.string,
  // subtitle: PropTypes.string,
  // legend: PropTypes.string,
  deputiesCount: PropTypes.number
}

export default HemicycleFocus



// WEBPACK FOOTER //
// ./src/components/main/HemicycleFocus.js